// import React, { useEffect, useState } from 'react';
import PCB from '../../assets/PCB.svg';
// import moment from 'moment';
// import GaugeComponent from 'react-gauge-component';

// type Props = {};
// const hours = new Date().getHours();

const Appx1 = ({ AQIInfo, NoiseInfo, AQIColor, NoiseData }: any) => {
  // Your component code here

  // Logging the props passed to the component
  // console.log('AQIInfo City:', AQIInfo[0]?.AQI);
  // console.log('NoiseInfo:', NoiseInfo);
  // console.log('AQIColor:', AQIColor);
  // console.log("AQIInfoToday:", AQIInfoToday.data);
 
  console.log("Noise Wb :: ",NoiseInfo, NoiseData, NoiseData.color);

  // useEffect(() => {
  //   const limit = isDayTime ? 65 : 55;

  //   // console.log('isNOi S: ', NoiseInfo, isDayTime, limit, NoiseInfo?.laeqt);
  //   // console.log("es : ",limit < NoiseInfo?.laeqt )
  //   if (limit < NoiseInfo?.laeqt) {
  //     setNoiseColor({ laeqt: NoiseInfo?.laeqt, color: '#FF0000' });
  //   } else {
  //     setNoiseColor({ laeqt: NoiseInfo?.laeqt, color: '#00af50' });
  //   }
  // },[]);

  // console.log('noise color W :: ', NoiseData?.color);
  return (
    <div className="flex justify-center items-center bg-[#181818]">
     <div className="flex h-[320px] w-[1100px] overflow-hidden">
    {/* // <div className="flex justify-center items-center w-screen h-screen   bg-white"> */}
 {AQIColor?.color && <div className="h-[391px] w-[1344px] shrink-0 bg-sky-300 origin-top-left scale-[0.81845]  justify-center  items-center ]">
      {/* Left screen */}
      {/* <div className="h-[311px] w-[1344px] bg-sky-300 w-3/8 mt-8 ml-5 scale-y-[1.0] scale-x-[1.0] justify-center items-center"> */}
      {/* Header */}
      <div className="flex">
        <div className="scale-x-[1.0]">
          <div className="mt-[60px]">
            {/* <div className="ml-[250px] mt-0"> Adjust margin as needed
               <h1 className="text-[#10A8FF] text-4xl font-semibold">Save</h1> */}
            <img src={PCB} className="size-20 ml-[234px] mt-[-10px] object-contain" />

            <div className="mt-[3px]">
              {/* <h1 className=" text-[#181818] text-sm font-semibold ml-[100px] mt-[-10px]">
                West Bengal Pollution Control Board
              </h1> */}
              <div className="mt-[24px]">
                <h1 className="text-[#181818] text-center text-4xl font-semibold ml-[-640px] ">
                    WBPCB Office, Salt Lake
                </h1>

                
                <div className="mt-[60px]">
                  <h1
                    style={{
                      backgroundColor: AQIColor?.color,
                      display: 'inline-block',
                    }}
                    className="text-black  text-4xl font-bold rounded ml-[40px] px-3"
                  >
                    {AQIInfo && AQIInfo[0] && AQIInfo[0]?.AQI !== undefined && !isNaN(AQIInfo[0]?.AQI) ? Number(AQIInfo[0]?.AQI).toFixed(2) : "00.00"}
                  </h1>
                  <div className="mt-[7px]">
                    <h1 className="text-[#181818] text-center text-4xl font-bold ml-[-981px]  ">
                      AQI
                    </h1>
                  </div>
                </div>



                <div className="mt-[-87px] ml-5">
                  <h1
                    style={{
                      backgroundColor: NoiseData?.color,
                      display: 'inline-block',
                    }}
                    className="text-black  text-4xl font-bold rounded ml-[217px] px-3"
                  >
                     {NoiseInfo?.laeqt !== null && NoiseInfo?.laeqt !== undefined ?
                      Number(NoiseInfo?.laeqt).toFixed(2) :
                      "00.00"} dB(A)
                  </h1>
                  <div className="mt-[7px] ml-10 ">
                    <h1 className="text-[#181818]  text-center text-4xl font-bold ml-[-537px] ">
                      Commercial
                    </h1>
                  </div>
                </div>
                <div className="mt-[-294px]">
                  <h1 className="text-[#181818] text-5xl font-semibold text-center ml-[523px] w-[64%]">
                    Save Nature, Save Future!
                  </h1>

                  {/* Table */}
                  <div className="rounded mt-[10px]  ml-[523px] h-[20%] w-[64%]">
                    {/* Rows */}
                    <div className="grid grid-cols-7 grid-rows-4">
                      {/* Row 1 */}
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-y-[1px] border-l-[1px] border-r-[1px]  py-[1px]">
                        Pollutant
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-y-[1px] border-b-[1px] border-r-[1px] py-[1px]">
                        PM<sub>2.5</sub>(&micro;g/m³)
                      </div>
                      <div className="flex justify-center items-center  text-sm text-[#181818] font-semibold border-black border-y-[1px] border-r-[1px] py-[1px]">
                        PM<sub>10</sub>(&micro;g/m³)
                      </div>
                      <div className="flex justify-center items-center  text-sm text-[#181818] font-semibold border-black border-y-[1px] border-r-[1px]  py-[1px]">
                        NO<sub>2</sub>(&micro;g/m³)
                      </div>
                      <div className="flex justify-center items-center  text-sm text-[#181818] font-semibold border-black border-y-[1px] border-r-[1px]  py-[1px]">
                        SO<sub>2</sub>(&micro;g/m³)
                      </div>
                      <div className="flex justify-center items-center  text-sm text-[#181818] font-semibold border-black border-y-[1px] border-r-[1px]  py-[1px]">
                        Temp(°C)
                      </div>
                      <div className="flex justify-center items-center  text-sm text-[#181818] font-semibold border-black border-y-[1px]  border-r-[1px] py-[1px]">
                        RH (%)
                      </div>
                      {/* Rows 2*/}
                      <div className="flex justify-center items-center text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Min
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.pm25_min || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.pm10_min || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.no2_min || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.so2_min || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.int_temp_min || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.int_humi_min || 0).toFixed(2)}
                      </div>
                      {/* Rows 3 */}
                      <div className="flex justify-center items-center  text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Avg
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.pm25_avg || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.pm10_avg || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.no2_avg || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.so2_avg || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.int_temp_avg || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.int_humi_avg || 0).toFixed(2)}
                      </div>
                      {/* Rows 4 */}
                      <div className="flex justify-center items-center  text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Max
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.pm25_max || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.pm10_max || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.no2_max || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.so2_max || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.int_temp_max || 0).toFixed(2)}
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        {Number(AQIInfo[0]?.int_humi_max || 0).toFixed(2)}
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                  {/* ----------------------------- */}
                  {/* Table */}
                  <div className="rounded mt-[10px]  ml-[523px] h-[20%] w-[64%]">
                    {/* Rows */}
                    <div className="grid grid-cols-3 grid-rows-5">
                      {/* Row 1 */}
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-y-[1px] border-l-[1px] border-r-[1px]  py-[1px]">
                        Noise Limit
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-y-[1px] border-b-[1px] border-r-[1px] py-[1px]">
                        Day (6 AM-10 PM) in dB(A)
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-y-[1px] border-r-[1px] py-[1px]">
                        Night (10 PM-6 AM) in dB(A)
                      </div>
                      {/* Rows 2*/}
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Industrial
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        75
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        70
                      </div>
                      {/* Rows 3 */}
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Commercial
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        65
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        55
                      </div>
                      {/* Rows 4 */}
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Residential
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        55
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        45
                      </div>
                      {/* Rows 5 */}
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-l-[1px] border-r-[1px] py-[1px]">
                        Silence
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px] border-r-[1px] py-[1px]">
                        50
                      </div>
                      <div className="flex justify-center items-center text-sm text-[#181818] font-semibold border-black border-b-[1px]  border-r-[1px] py-[1px]">
                        40
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>

          {/* Right screen */}
          {/* <div className="h-[311px] w-[1344px] bg-sky-300 w-5/8  mt-8 mr-1 scale-y-[1.0] scale-x-[1.0] justify-center item-center"> */}

          {/* ------------------------------- */}
        </div>
      </div>
    </div> }
    </div>
    </div>
  );
};

export default Appx1;
